import Vue from 'vue'
import App from './App.vue'
import router from './router'


import { getCookie } from './untils/tools';
Vue.prototype.getCookie = getCookie

router.beforeEach((to, from, next) => {
    const token = getCookie();
    if (!token && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
});

import './plugins/element.js'
import BaiduMap from 'vue-baidu-map';
import { BmlMarkerClusterer } from 'vue-baidu-map';
//引入点聚合
Vue.component('bml-marker-cluster', BmlMarkerClusterer);
//引入百度地图
Vue.use(BaiduMap, {
    ak: 'Kj14fo8LHUgbsDH5NMoA3qFE3SyLitDA'
});

import request from './untils/request'


Vue.prototype.request = request
Vue.config.productionTip = false

if (false) {
    Vue.prototype.baseUrl = 'http://inspectapi.test.cn/'
    Vue.prototype.commUrl = 'http://inspectapi.test.cn/Commonapi/'
} else {
    //http://inspectapi.zhiyanglao.cn/控制器/方法名
    //http://inspectapi.zhiyanglao.cn/index.php/institution/控制器/方法名
    //控制器 Login Institution
    Vue.prototype.baseUrl = 'https://inspectapi.zhiyanglao.cn/'
    Vue.prototype.commUrl = 'https://inspectapi.zhiyanglao.cn/Commonapi/'
}
//二维码
Vue.prototype.getGenerator = 'https://api.2dcode.biz/v1/create-qr-code/?'
new Vue({
    router,
    render: h => h(App)
}).$mount('#app') 
